import GlyphIcon from "./GlyphIcon.mjs";

const ReadIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M30.30762,14.36768C28.25488,12.002,22.751,6.5,16,6.5S3.74512,12.002,1.69336,14.36572a2.49922,2.49922,0,0,0-.001,3.2666C3.74512,19.99805,9.249,25.5,16,25.5s12.25488-5.502,14.30762-7.86768A2.49888,2.49888,0,0,0,30.30762,14.36768ZM9.24042,20.25977A25.33965,25.33965,0,0,1,4.25391,16a25.33613,25.33613,0,0,1,4.98657-4.25977,7.93436,7.93436,0,0,0-.00006,8.51954ZM16,22a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,16,22Zm6.75952-1.74023a7.93436,7.93436,0,0,0,.00006-8.51954A25.33965,25.33965,0,0,1,27.74609,16,25.33613,25.33613,0,0,1,22.75952,20.25977ZM19,16a3.00014,3.00014,0,1,1-5.80646-1.03174,1.49952,1.49952,0,0,0,1.77472-1.77466A2.97577,2.97577,0,0,1,19,16Z"
				{...this.props}
			/>
		);
	}
}

export default ReadIcon;